export const regionQueryKeys = {
  all: () => "region"
};
